import React from "react";
import styled from "styled-components";
import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";

interface IButton {
  name?: string | React.ReactNode;
  icon?: React.ReactNode;
  onClick?: (e?: any) => void;
  background?: string;
  color?: string;
  fontSize?: number;
  fontWeight?: number;
  lineHeight?: string;
  padding?: string;
  width?: string;
  bdr?: string; // border radius
  border?: string;
  margin?: string;
  type?: "button" | "submit" | "reset" | undefined;
  disabled?: boolean;
  className?: any;
  style?: React.CSSProperties;
  loading?: boolean;
  size?: number;
}

const ButtonStyled = styled.button<IButton>(
  ({
    theme,
    background,
    color,
    fontSize,
    fontWeight,
    lineHeight,
    padding,
    width,
    bdr,
    border,
    margin,
  }) => ({
    position: "relative",
    color: color,
    background: background,
    fontSize: fontSize || theme.sizes.xs,
    fontWeight: fontWeight || 500,
    lineHeight: lineHeight,
    padding: padding,
    borderRadius: bdr || 6,
    border: border,
    width: width,
    margin: margin,
    textTransform: "capitalize",
    transition: "background 0.2s ease",
    "&:hover": {
      cursor: "pointer",
    },
    "&:disabled": {
      background: theme.colors.border,
      cursor: "no-drop",
    },
    "&:focus": {
      borderColor: "transparent",
    },
    // "&:focus": {
    //   border: "none",
    // },
  })
);

const Button: React.FC<IButton> = ({
  name,
  icon,
  loading = false,
  size = 20,
  ...rest
}) => {
  return (
    <ButtonStyled {...rest}>
      {loading ? (
        <Spin
          indicator={
            <LoadingOutlined style={{ fontSize: size, color: "white" }} spin />
          }
          size="small"
        />
      ) : (
        <>
          {icon && <span style={{ marginRight: 5 }}>{icon}</span>}
          {name}
        </>
      )}
    </ButtonStyled>
  );
};

export default Button;
